<template>
<div>
  <v-container fluid class="secondary">
    <v-row align="center">
      <v-col cols="3" md="2" xl="1" class="">
        <image-picker dark color="white" :size="125" :value="$store.state.account.account.profile_image" @input="$store.dispatch('account/update',{profile_image: $event})"></image-picker>
      </v-col>
      <v-col cols="8" md="10" xl="10" class="text-center text-md-left">
        <h1 class="white--text">{{$store.state.account.account.business}}</h1>
        <h4 class="grey--text">{{$store.state.account.account.name}}</h4>
      </v-col>
    </v-row>
  </v-container>
  <div class="secondary lighten-1 white--text">
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center">
          <h2>Contests</h2>
        </v-col>

      </v-row>
    </v-container>
  </div>


  <v-container style="padding-top:50px;padding-bottom:50px">
    <v-row align="center">
      <v-col cols="12" md="4" lg="3" class="text-center" style="padding:50px">
        <v-btn class="ml-2" fab x-large color="primary" @click="$eventBus.$emit('create_contest')">
          <v-icon>fa-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" lg="3" v-for="(contest,i) in contests" :key="i">
        <router-link class="nolink" :to=" contest.status===0 ? '' : `/business/contest/${contest.id}`">
          <v-card>

            <!--
          <v-img :aspect-ratio="16/9" :src="contest.brand_logo" v-if="contest.status===0">
            <v-row class="lightbox white--text pa-2 fill-height">
            </v-row>
          </v-img>
          <router-link class="nolink" :to="`/business/contest/${contest.id}`" v-else>
            <v-img :aspect-ratio="16/9" :src="contest.brand_logo">
              <v-row class="lightbox white--text pa-2 fill-height">
              </v-row>
            </v-img>
          </router-link>
          !-->

            <div class="contest-box" :style="`background-image:url(${contest.promo_poster ? contest.promo_poster : '/placeholder_large.png'})`">
              <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="contest.status===0" style="z-index:1">

              </v-overlay>
            </div>



            <v-card-actions class="grey lighten-3">
              <h5><v-icon class="mr-2" small :color="contest.status==0 ? 'grey' : contest.status===1 ? 'blue' : 'green' " dark>fa-circle</v-icon> {{contest.status===0 ? 'In Review' :  contest.status===1 ? 'In Progress' : 'Completed'}}</h5>

              <v-spacer></v-spacer>
            </v-card-actions>


          </v-card>
        </router-link>
      </v-col>
    </v-row>

  </v-container>


</div>
</template>
<script>
import imagePicker from "@/components/app/image-picker-2";

export default {
  name: "",
  components: {
    imagePicker
  },
  data: () => ({
    contests: [],
    loading: true,
    logo: ''
  }),
  created() {
    this.$eventBus.$on('created_contest', this.load)
  },
  methods: {
    async load() {
      this.loading = true;
      this.contests = await this.$api(`/account/business/contests`)
      this.loading = false;
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.load()
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.load()
    next()
  }
}
</script>
<style lang="scss" scoped>
.contest-box {
    width: 100%;
    height: 270px;
    background-size: contain;
    background-position: center;
    position: relative;
}
</style>
